import { FocusScope } from "@radix-ui/react-focus-scope";

import { Column, RejectReasonForm } from "@/components";

import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";

import { ScreeningStepHeader } from "./ScreeningStepHeader";

// Potential step 2 rejecting in "Screening in Progress" modal - giving rejection reason post-screen
export const RejectReasonStep = ({
  isUpdatePending,
  onBack,
  onConfirm,
  onDismiss,
}: {
  isUpdatePending: boolean;
  onBack: () => void;
  onConfirm: (justification: string) => void;
  onDismiss: () => void;
}) => {
  return (
    <FocusScope
      trapped
      loop
      onMountAutoFocus={(e) => {
        e.preventDefault();
      }}
    >
      <Column className="gap-0">
        <ScreeningStepHeader
          title="Reject candidate"
          onBack={onBack}
          onDismiss={onDismiss}
        />
        <Column className="px-3.5 pb-2.5 pt-2">
          <RejectReasonForm
            isCompact
            isPending={isUpdatePending}
            label="Rejection reason"
            mixpanelScreen={MIXPANEL_SCREENS.DASHBOARD}
            onConfirm={onConfirm}
          />
        </Column>
      </Column>
    </FocusScope>
  );
};
